/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { createTheme, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { Container, ThemeProvider, Typography, Box } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { postMergeTheme, preMergeTheme } from '../theming/theme';
import Button from '../../components/common/Button';
import { selectVersion } from '../../redux/features/configuration/configuration.slice';
import { dataTestId } from '../utils/versionUtils';

const useStyles = theme =>
  makeStyles(() => ({
    container: {
      color: theme.palette.secondary.contrastText,
      minHeight: 'calc(100vh - 9.1875rem)', // 100% of viewport - (header + footer)
      marginLeft: '9.2%',
    },
    title: {
      fontWeight: '500',
      fontSize: '4rem',
      paddingTop: '2rem',
      paddingBottom: '1rem',
      zIndex: '1',
      position: 'relative',
      [theme.breakpoints.up('xl2')]: {
        fontSize: '6.25rem',
        paddingTop: '3rem',
      },
    },
    cancelIcon: {
      color: theme.palette.footerBackground,
      width: '36.3rem',
      height: '36.3rem',
      position: 'fixed',
      right: '-4.38%',
      bottom: '-5.71%',
    },
    textDiv: {
      zIndex: '1',
      position: 'relative',
    },
    link: {
      textDecoration: 'none',
    },
    buttonBox: {
      marginTop: '2.875rem',
    },
  }));

export function NotFound() {
  let theme = createTheme(preMergeTheme, {});
  theme = createTheme(theme, postMergeTheme(theme));

  const classes = useStyles(theme)();
  const { t } = useTranslation();
  const selectedVersion = useSelector(selectVersion);

  const title = 'error.page.notFound.title';
  const message = 'error.page.notFound.message';

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="xl" className={classes.container}>
        <Box className={classes.textDiv}>
          <Typography className={classes.title} variant="h1">
            <span className={classes.title}>{t('error.page.title')}</span>
          </Typography>
          <Typography variant="h3">{t(title)}</Typography>
          <Typography>{t(message)}</Typography>
        </Box>
        <Box className={classes.buttonBox}>
          <Link to="/" className={classes.link}>
            <Button {...dataTestId({ value: `backToHomeButton-${selectedVersion.value}` })} color="primary">
              {t('actions.back.NotFound')}
            </Button>
          </Link>
        </Box>
        <CancelIcon className={classes.cancelIcon} />
      </Container>
    </ThemeProvider>
  );
}
